<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!-- Insert here -->
              <h4>Transaction report</h4>
              <table class="table border table-striped">
                <tbody>
                  <tr>
                    <td style="width: 150px"><label>Name:</label></td>
                    <td>{{ Name }}</td>
                  </tr>
                  <tr>
                    <td><label>Username:</label></td>
                    <td>{{ Username }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- Button row Start -->
              <div class="buttonRow">
                <router-link
                  class="btn btn-primary mr-3"
                  :to="{
                    name: 'DivvyAdminUsersEditUser',
                  }"
                  @click.native="scrollToTop"
                >
                  Edit
                </router-link>
                <router-link
                  class="btn btn-primary mr-3"
                  :to="{
                    name: 'DivvyAdminUsersPointsUpdate',
                  }"
                  @click.native="scrollToTop"
                >
                  Points
                </router-link>
                <router-link
                  class="btn btn-primary"
                  :to="{ name: 'Users' }"
                  @click.native="scrollToTop"
                >
                  User Manager
                </router-link>
              </div>
              <!-- Button row End-->
              <div v-if="!ReportsPageResult" class="border rounded mt-2 mb-2">
                <fieldset class="text-center">
                  <br /><br /><br />
                  <p>
                    There are no transactions that match the criteria that you
                    have selected. Please click the Back button in your browsers
                    and try again.
                  </p>
                  <br /><br /><br />
                </fieldset>
              </div>
              <div v-if="ReportsPageResult">
                <div
                  class="form-inline mt-2 mb-2 d-flex"
                  style="align-items: center;"
                >
                  <span class="ml-2" style="flex-grow: 1;"
                    >Click on any column header to sort on that column. Click
                    again to reverse order.</span
                  >
                  <label
                    >Search:<input
                      @keydown="updateReportResults"
                      v-model="SearchTerm"
                      type="search"
                      class="form-control input-sm ml-1"
                  /></label>
                </div>
                <div class="table-responsive">
                  <table
                    id="transactionList"
                    class="table border table-striped table-hover"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = '[CLIENT_NAME]';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Client
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = '[DATE]';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Date
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = 'TYPE';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Type
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = '[BYWHOM_USERNAME]';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          By
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = 'DOLLARS';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Dollars
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = 'POINTS';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Points
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = 'PRODUCT';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Product
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = 'ORDER_NUMBER';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Order Number
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = 'PROGRAM';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Program
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer"
                          @click="
                            () => {
                              let field = 'COMMENTS';
                              setSortFieldAndOrder(field);
                            }
                          "
                        >
                          Comments
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        role="row"
                        class="odd"
                        v-for="(Res, i) in ReportsPageResult.Result"
                        :key="i"
                      >
                        <td v-html="Res.client_name"></td>
                        <td style="text-align: center">
                          {{ convertToMonthDayYear(Res.date) }}
                        </td>
                        <td>{{ Res.type }}</td>
                        <td>
                          <span v-if="Res.by_whom_user_name">
                            {{ Res.by_whom_user_name }}</span
                          >
                          <span
                            v-if="!Res.by_whom_user_name"
                            style="color: grey;"
                            >n/a</span
                          >
                        </td>

                        <td>
                          {{ Res.dollars }}
                        </td>
                        <td>
                          {{ Res.points }}
                        </td>
                        <td>
                          <span v-if="Res.product">{{ Res.product }}</span>
                          <span v-if="!Res.product" style="color: grey;"
                            >n/a</span
                          >
                        </td>
                        <td>
                          <span v-if="Res.order_number">{{
                            Res.order_number
                          }}</span>
                          <span v-if="!Res.order_number" style="color: grey;"
                            >n/a</span
                          >
                        </td>
                        <td>
                          <span v-if="Res.program">({{ Res.program }})</span>
                          <span v-if="!Res.program" style="color: grey;"
                            >n/a</span
                          >
                        </td>
                        <td v-html="Res.comments"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row">
                  <div class="col-sm-5">
                    <div class="">
                      Showing {{ 1 * TotalRecords }} to {{ TotalRecords }} of
                      {{ TotalRecords }} entries
                    </div>
                  </div>
                </div>

                <p class="text-right mb-3" style="color: black">
                  <strong
                    >Total points: {{ ReportsPageResult.totalPoints }}</strong
                  >
                </p>
              </div>

              <!-- Insert here -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import { convertToMonthDayYear } from "../../../../utilities/date.js";

export default {
  name: "UsersReportUser",
  props: ["id"],
  data() {
    return {
      Name: "",
      Username: "",
      PageSize: 100,
      PageNumber: 1,
      TotalRecords: 0,
      SearchTerm: "",
      SortField: "",
      SortOrder: "",
    };
  },
  components: {
    DivvyAdminSidebar,
    Header,
    Footer,
  },

  computed: {
    ReportsPageResult() {
      return this.$store.getters["manageUsers/getReportspageResult"];
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersmodule",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
    setData(data) {
      if (data.firstName && data.lastName) {
        this.Name = data.firstName + "," + data.lastName;
      } else if (data.firstName) {
        this.Name = data.firstName + ",";
      } else if (data.lastName) {
        this.Name = "," + data.lastName;
      }
      this.Username = data.username;
    },
    setSortFieldAndOrder(field) {
      this.SortField = field;

      if (this.SortOrder === "ASC") {
        this.SortOrder = "DESC";
      } else {
        this.SortOrder = "ASC";
      }

      this.updateReportResults();
    },
    updateReportResults() {
      this.$store.dispatch("manageUsers/setReportResults", {
        pg_num: this.PageNumber,
        pg_size: this.PageSize,
        sort_field: this.SortField,
        sort_order: this.SortOrder,
        userId: Number(this.id),
        search_term: this.SearchTerm,
      });
    },
    convertToMonthDayYear,
  },

  created() {
    window.scroll(0, 0);
    this.setActiveMenuItem();

    this.$store
      .dispatch("manageUsers/fetchExistingDetails", {
        userId: this.id,
      })
      .then((data) => {
        console.log(data);
        this.setData(data);
      });

    this.$store
      .dispatch("manageUsers/setReportResults", {
        pg_num: this.PageNumber,
        pg_size: this.PageSize,
        sort_field: this.SortField,
        sort_order: this.SortOrder,
        userId: Number(this.id),
        search_term: this.SearchTerm,
      })
      .then((data) => {
        this.PageNumber = data.pageNumber;
        this.PageSize = data.pageSize;
        this.TotalRecords = data.totalRecords;
        this.SortField = data.sortField;
        this.SortOrder = data.sortOrder;
      });
  },
  destroyed() {
    this.$store.commit("manageUsers/SET_REPORT_RESULTS", []);
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
